module.exports = __webpack_public_path__ + "image/model-logo_2.1782790484418.png";